import { render } from "./AbsenceTypes.vue?vue&type=template&id=dfe35834&scoped=true"
import script from "./AbsenceTypes.vue?vue&type=script&lang=js"
export * from "./AbsenceTypes.vue?vue&type=script&lang=js"

import "./AbsenceTypes.vue?vue&type=style&index=0&id=dfe35834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe35834"]])

export default __exports__